
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const GarantiaCabDB = async ({ id_cab_inst, folio, confirmado, estado, diagnostico, cerrado, fecha_cerrado, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'bitacoracabgarantia'), {
        id_cab_inst: id_cab_inst,
        folio: folio,
        confirmado: confirmado,
        estado: estado,
        diagnostico: diagnostico,
        cerrado: cerrado,
        fecha_cerrado: fecha_cerrado,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default GarantiaCabDB;